<script setup lang="ts">
import type { ArticleContent } from '~/models/Content/ArticleContent'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'

defineProps<{
  articleContent: ArticleContent
}>()
</script>

<template>
  <div v-if="articleContent.body" class="au-prose col-[text]">
    <RichTextRenderer :text="articleContent.body" />
  </div>
</template>
